import { getAllNetworks } from "@iota/iota-sdk/client";
const SUPPORTED_CHAINS = Object.values(getAllNetworks()).map((network) => network.chain);
function isSupportedChain(chain) {
  return SUPPORTED_CHAINS.includes(chain) || chain.split(":")[0] === "iota";
}
export {
  SUPPORTED_CHAINS,
  isSupportedChain
};
//# sourceMappingURL=chains.js.map
